// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__10leM","success":"FinishedQuiz_success__3xrfs","error":"FinishedQuiz_error__2BD3j"};